const zhCN = {
  payTypes: {
    BALANCE_PAY: '余额支付',
    COUPON_PAY: '卡券支付'
  },
  chargingType: {
    COST_PER_TIMES: '按次定额收费'
    // COST_PER_PRICE: '按单价计费'
  },
  needBooking: {
    true: '先预订后就餐',
    false: '不需预订'
  },
  week: {
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    sunday: '周日'
  },
  openStatus: {
    UNSUBSCRIBE: '已注销',
    UNOPENED: '未开通',
    OPENNING: '已开通',
    CLOSED: '到期已关闭'
  },
  rechargeStatus: {
    PRE_RECHARGE: '发起充值',
    RECHARGEING: '正在充值',
    RECHARGED: '充值成功',
    UNRECHARGED: '充值失败'
  },
  rechargeType: {
    WECHAT_PAY: '微信支付',
    ALI_PAY: '支付宝支付',
    HAND_PAY: '手动系统充值'
  },
  bookingStatus: {
    CANCEL: '已取消',
    BOOKING: '预定中',
    BOOKED: '已预定'
  },
  personType: {
    STAFF: '员工',
    VISITOR: '访客',
    STRANGER: '陌生人'
  },
  mealStatus: {
    EXPIRE: '过期未使用',
    CANCEL: '已取消',
    UNUSED: '未使用',
    USED: '已使用'
  },
  meetingStatus: {
    CANCEL: ['已取消', '#919191'],
    AUDITING: ['待审核', '#F76260'],
    AUDIT_OUTTIME: ['超时未审核', '#F2B230'],
    AUDIT_FAIL: ['未过审', '#333333'],
    BE_START: ['待开始', '#F2B230'],
    MEETING: ['会议中', '#3B86FF'],
    FINISH: ['已完成', '#2DCC2C']
  },
  signStatus: {
    CANCEL: ['已取消', '#919191'],
    UNSIGNIN: ['未签到', '#F2B230'],
    SIGNIN: ['已签到', '#3B86FF'],
  }
};

function GetObjectList(name) {
  const json = zhCN[name];
  const keyList = Object.keys(json);
  const list = [];
  keyList.forEach((item, index) => {
    const value = { id: index, value: item, label: json[item] };
    list.push(value);
  });
  return list;
}

function GetObjectListName(list, name) {
  const data = [];
  list.forEach((item) => {
    data.push(zhCN[name][item]);
  });
  return data.join('、');
}

export default {
  zhCN,
  GetObjectList,
  GetObjectListName
};
